import { InjectionToken } from '@angular/core';
var AvcCoreDataBaseUrl = /*#__PURE__*/function (AvcCoreDataBaseUrl) {
  AvcCoreDataBaseUrl["DEV"] = "https://avc-coredata-dev.garmin.com";
  AvcCoreDataBaseUrl["TEST"] = "https://avc-coredata-test.garmin.com";
  AvcCoreDataBaseUrl["STAGE"] = "https://avc-coredata-stg.garmin.com";
  AvcCoreDataBaseUrl["PROD"] = "https://avc-coredata.garmin.com";
  return AvcCoreDataBaseUrl;
}(AvcCoreDataBaseUrl || {});
var FlyGarminBaseUrl = /*#__PURE__*/function (FlyGarminBaseUrl) {
  FlyGarminBaseUrl["DEV"] = "https://flydev.garmin.com";
  FlyGarminBaseUrl["TEST"] = "https://flytest.garmin.com";
  FlyGarminBaseUrl["STAGE"] = "https://flystg.garmin.com";
  FlyGarminBaseUrl["PROD"] = "https://fly.garmin.com";
  return FlyGarminBaseUrl;
}(FlyGarminBaseUrl || {});
var ServicesBaseUrl = /*#__PURE__*/function (ServicesBaseUrl) {
  ServicesBaseUrl["DEV"] = "https://avcloud-api-dev.garmin.com";
  ServicesBaseUrl["TEST"] = "https://avcloud-api-test.garmin.com";
  ServicesBaseUrl["STAGE"] = "https://avcloud-api-stg.garmin.com";
  ServicesBaseUrl["PROD"] = "https://avcloud-api.garmin.com";
  return ServicesBaseUrl;
}(ServicesBaseUrl || {});
const WEB_DATA_SERVICES_CONFIG = new InjectionToken('WEB_DATA_SERVICES_CONFIG');

/**
 * Generated bundle index. Do not edit.
 */

export { AvcCoreDataBaseUrl, FlyGarminBaseUrl, ServicesBaseUrl, WEB_DATA_SERVICES_CONFIG };
